<template>
  <div class="hzx_title_head">
    <div class="hzx_title_head_text1">
      <div :class="[color === 'black' ? 'black' : 'white']">
        {{ text1 }}
      </div>
    </div>
    <div class="hzx_title_head_text2">
      <div :class="[color === 'black' ? 'black' : 'white']">
        {{ text2 }}
      </div>
    </div>
    <div :class="[color === 'black' ? 'hzx_title_head_line_black' : 'hzx_title_head_line_white']"></div>
    <div v-if="text3" class="hzx_title_head_text3">
      {{ text3 }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'Head',
  props: {
    color: {
      type: String,
      default: 'black'
    },
    text1: String,
    text2: String,
    text3: String
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped lang="scss">
  .hzx_title_head {
    text-align: center;
    margin-top: 50px;
    .hzx_title_head_text1 {
      font-size: 28px;
      .black {
        color: rgba(51, 51, 51, 1);
      }
      .white {
        color: rgba(255, 255, 255, 1);
      }
    }
    .hzx_title_head_text2 {
      margin-top: 15px;
      font-size: 16px;
      .black {
        color: rgba(153, 153, 153, 1);
      }
      .white {
        color: rgba(255, 255, 255, 1);
      }
    }
    .hzx_title_head_line_black {
      margin: 15px auto;
      width: 300px;
      height: 20px;
      background-image: url('../../../assets/img/line1.png');
      background-size: 100% 100%;
    }
    .hzx_title_head_line_white {
      margin: 15px auto;
      width: 300px;
      height: 20px;
      background-image: url('../../../assets/img/line1.png');
      background-size: 100% 100%;
    }
    .hzx_title_head_text3 {
      margin-top: 45px;
      font-size: 28px;
      font-weight: 700;
      color: #000;
    }
  }
</style>
